import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref, computed as _computed } from 'vue';

import i18n from '@/i18n';
import { getModule } from 'vuex-module-decorators';
import authModule from '@/store/modules/auth';
import businessGlossaryModule from '@/store/modules/business-glossary';
import store from '@/store';
import BusinessGlossaryTermsEdit from '@/components/business-glossary/Business-Glossary-Terms-Edit.vue';
import BusinessGlossaryDrawerLinked from '@/components/business-glossary/business-glossary-drawer/Business-Glossary-Drawer-Linked.vue';
import { TermService, TagWithAssetsDto, TagDto } from '@/api';
import ModalDialog from '@/components/modal-dialog/Modal-Dialog.vue';
import Vue, { onBeforeUnmount, onMounted, watch } from 'vue';
import SRichTextViewer from '@/components/SRichTextViewer.vue';

type BusinessGlossaryDrawerEmits = {
  (event: 'set-title', title: string): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Business-Glossary-Drawer',
  emits: ["set-title"],
  setup(__props, { emit: emits }) {


const DEFAULT_OPTIONS = {
  page: 1,
  itemsPerPage: 25,
};

const auth = getModule(authModule, store);
const terms = getModule(businessGlossaryModule, store);

const businessGlossaryTermsEditRef = _ref<InstanceType<typeof BusinessGlossaryTermsEdit>>();
const modalDialog = _ref<InstanceType<typeof ModalDialog>>();
const activeTab = _ref(0);

let assetFilterType = _ref<('TABLE_AND_VIEW' | 'DASHBOARD' | 'PIPELINE' | 'MONITOR' | 'GENERIC') | undefined >(undefined);

let options = _ref(DEFAULT_OPTIONS);

let term = _ref<TagWithAssetsDto>({
  id: '',
  name: '',
  description: '',
  type: TagWithAssetsDto.type.TERM,
  assets: {
    data: [],
    totalElements: 0,
  },
});

let loading = _ref<boolean>(false);

const linkedLength = _computed(() => term.value?.assetCount || 0);
const description = _computed<string>(() => term.value?.description || '');
const assets = _computed(() => term.value?.assets || []);
const selectedTerm = _computed<TagDto | null>(() => terms.selectedTerm);
const termId = _computed(() => terms.selectedTerm?.id);
const canEdit = _computed(() => auth.userActions['metadata.term.write']);
const canDelete = _computed(() => auth.userActions['metadata.term.write']);

const getTermWithAssets = async () => {
  if (!termId.value) return;
  loading.value = true;
  term.value = await TermService.getTermWithAssets({
    tagId: terms.selectedTerm?.id,
    page: options.value.page,
    itemsPerPage: options.value.itemsPerPage,
    assetFilterType: assetFilterType.value ? [assetFilterType.value] : undefined,
  });
  emits('set-title', term.value.name);
  loading.value = false;
};

const validateCallback = () => {
  terms.searchTerms();
  getTermWithAssets();
};

const editTerm = () => {
  businessGlossaryTermsEditRef.value?.editTerm();
};

const deleteSingleTerm = () => {
  modalDialog.value?.openDialog();
};

const resetTerm = () => {
  term.value = {
    id: '',
    name: '',
    description: '',
    type: TagWithAssetsDto.type.TERM,
    assets: {
      data: [],
      totalElements: 0,
    },
  };
};

const resetOptions = () => {
  options.value = {
    page: 1,
    itemsPerPage: 25,
  };
};

const resetFilter = () => {
  assetFilterType.value = undefined;
};

const init = () => {
  terms.removeSelectedTerm();
  resetTerm();
  resetOptions();
  resetFilter();
  Vue.prototype.$rightDrawer?.closeDrawer();
};

const deleteTerm = async () => {
  modalDialog.value?.closeDialog();
  await TermService.deleteTerm({ id: term.value.id });
  Vue.notify({
    text: i18n.t('glossary.delete_terms_success', { name: term.value.name }),
  });
  await terms.searchTerms();
  init();
};

const updateFilter = (newAssetFilterType: 'TABLE_AND_VIEW' | 'DASHBOARD' | 'PIPELINE' | 'MONITOR' | undefined) => {
  assetFilterType.value = newAssetFilterType;
  getTermWithAssets();
};

watch(() => termId.value, async () => {
  if (termId.value) await getTermWithAssets();
});

watch(() => options.value, () => {
  getTermWithAssets();
});

onMounted(() => {
  getTermWithAssets();
});

onBeforeUnmount(() => {
  init();
});

return { __sfc: true,emits, DEFAULT_OPTIONS, auth, terms, businessGlossaryTermsEditRef, modalDialog, activeTab, assetFilterType, options, term, loading, linkedLength, description, assets, selectedTerm, termId, canEdit, canDelete, getTermWithAssets, validateCallback, editTerm, deleteSingleTerm, resetTerm, resetOptions, resetFilter, init, deleteTerm, updateFilter, _ref, _computed, i18n, getModule, authModule, businessGlossaryModule, store, BusinessGlossaryTermsEdit, BusinessGlossaryDrawerLinked, TermService, TagWithAssetsDto, TagDto, ModalDialog, Vue, onBeforeUnmount, onMounted, watch, SRichTextViewer }
}

})